export default {
    title: 'IN PROGRESS',
    newFunction:{
        one: '“Drag and drop“ node in JSON Tree',
        two: 'Hierarchical view in full-text search of property or value'
    },
    newFeature: 'Do you have any additional comments or suggestions about possible improvements, please do not hesitate to contact me:<strong><a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a></strong>'
}
